import one from '../assets/svg/projects/seven.svg'
import two from '../assets/svg/projects/seven.png'
import three from '../assets/svg/projects/cashless-payment.png'
import four from '../assets/svg/projects/advertising.png'
import five from '../assets/svg/projects/learning-support.png'
import six from '../assets/svg/projects/online-reservation.png'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Delivering stock streams to 40M+ investors',
        projectDesc: 'Performance bottlenecks, Optimization of Server-side rendering, Rebuilding basic html to React Components',
        tags: ["React","Java", "Spring Boot", "Redux"],
        code: 'https://vacuumlabs.com/case-study/stocktwits/',
        demo: 'https://stocktwits.com/',
        image: one
    },
    {
        id: 2,
        projectName: 'Kerry Hotel Dynamic Event Signage',
        projectDesc: 'This project involves the Signage System of Kerry hotel. This product controls all signage units in the system.',
        tags: ["React", "Typescript", "MUI", "Mongo"],
        code: 'https://www.auralabs.com.hk/work/kerryhotel',
        demo: 'https://www.auralabs.com.hk/work/kerryhotel',
        image: two
    },
    {
        id: 3,
        projectName: 'Financial literacy of Bank App',
        projectDesc: 'Through workshops, testing, and multiple iterations, the Smartie app was born, which uses gamification to help teach youth how to save and spend money.',
        tags: ["React-Native", "Payment integration", "NodeJS"],
        code: 'https://vacuumlabs.com/case-study/smartie/',
        demo: 'https://365.bank/smartie',
        image: three
    },
    {
        id: 4,
        projectName: 'Cody Out of Home',
        projectDesc: 'The aim of the project is to create a system to facilitate the rotation of media distribution within a network of contracted Taxis.',
        tags: ["React-Native", "Nodejs", "Integration API"],
        code: 'https://www.auralabs.com.hk/work/cody',
        demo: 'https://www.auralabs.com.hk/work/cody',
        image: four
    },
    {
        id: 5,
        projectName: 'Digital transformation for School-Home Support',
        projectDesc: 'I set up a simple system to track these interactions, added privacy layers, and connected the tools they use every day. This has made it easier for SHS to view their data, showcase their achievements and get more support.',
        tags: ["Vue.js", "Bootstrap", "MySQL", "Spring Boot"],
        code: 'https://wearetelescopic.co.uk/our-work/digital-transformation-for-nonprofit-school-home-support/',
        demo: 'https://wearetelescopic.co.uk/our-work/digital-transformation-for-nonprofit-school-home-support/',
        image: five
    },
    {
        id: 6,
        projectName: 'Bookings made breezy for TARKA',
        projectDesc: 'This project allows parents to schedule classes with ease and saving the team time on phone bookings. We enhanced TARKA’s brand and designed and build a new website for smooth integration with the new booking system.',
        tags: ["Nodejs", "MongoDB", "React", "Typescript"],
        code: ' https://wearetelescopic.co.uk/our-work/childcare-and-education-website-tarka/',
        demo: ' https://wearetelescopic.co.uk/our-work/childcare-and-education-website-tarka/',
        image: six
    },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/